import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Tabs,
  Tab,
  Pagination,
} from "react-bootstrap";
import { MdOutlinePerson } from "react-icons/md";
import { AiFillGolden } from "react-icons/ai";
import { RiDeviceRecoverLine } from "react-icons/ri";
import API_DOMAIN from "../config/config";
import dayjs from "dayjs";
import "./tablecus.css";
import "bootstrap/dist/css/bootstrap.min.css";
import LoadingOverlay from "../../src/components/LoadingOverlay";
import { GrPrevious, GrNext } from "react-icons/gr";

const DashBoard = () => {
  const [userecoveryData, setUserrecoveryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [customerData, setcustomerData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [allPawnData, setAllPawnData] = useState([]);
  const [interestData, setInterestData] = useState([]);
  const [companyName, setCompanyName] = useState("ஸ்ரீ தேவி பைனான்ஸ்");

  const [searchTerm, setSearchTerm] = useState("");
  const [placeSearchTerm, setPlaceSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [fromDays, setFromDays] = useState("");
  const [toDays, setToDays] = useState("");
  const [alertStatusFilter, setAlertStatusFilter] = useState("");
  const [sentWhatsAppAlerts, setSentWhatsAppAlerts] = useState(() => {
    try {
      const stored = localStorage.getItem("sentWhatsAppAlerts");
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  });

  const [sentSmsAlerts, setSentSmsAlerts] = useState(() => {
    try {
      const stored = localStorage.getItem("sentSmsAlerts");
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  });

  const [totalRecords, setTotalRecords] = useState(0);              // Customers
  const [totalPawnRecords, setTotalPawnRecords] = useState(0);      // TOTAL pawn jewelry (no filter)
  const [filteredPawnRecords, setFilteredPawnRecords] = useState(0); // Filtered count (for pagination)

  const [pawnrecovertotalRecords, setpawnrecoverTotalRecords] = useState(0);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [tabKey, setTabKey] = useState("below");

  // Track if current fetch is from major change (tab/page)
  const isMajorChangeRef = useRef(false);

  // For debounce
  const debounceTimer = useRef(null);

  const parsePeriod = (period) => {
    let years = 0;
    let months = 0;
    let days = 0;

    if (!period) return { months, days };

    const yearMatch = period.match(/(\d+)\s*year(s)?/i);
    const monthMatch = period.match(/(\d+)\s*month(s)?/i);
    const dayMatch = period.match(/(\d+)\s*day(s)?/i);

    if (yearMatch) years = parseInt(yearMatch[1], 10);
    if (monthMatch) months = parseInt(monthMatch[1], 10);
    if (dayMatch) days = parseInt(dayMatch[1], 10);

    months += years * 12;

    return { months, days };
  };

  const isEligibleForAlert = (period) => {
    const { months, days } = parsePeriod(period);
    const totalPendingDays = Math.round((months * 30.4167) + days);
    return totalPendingDays >= 365;
  };

  const formatPeriod = (totalMonths) => {
    const finalMonths = totalMonths;
    return `${finalMonths} month${finalMonths !== 1 ? "s" : ""}`;
  };

  const aggregateInterestData = useMemo(() => {
    const aggregated = interestData.reduce((acc, item) => {
      const receiptNo = item.receipt_no;
      if (!acc[receiptNo]) {
        acc[receiptNo] = {
          total_interest_income: 0,
          total_months: 0,
        };
      }
      acc[receiptNo].total_interest_income += parseFloat(
        item.interest_income || 0
      );

      const { months } = parsePeriod(item.interest_payment_periods);
      acc[receiptNo].total_months += months;
      return acc;
    }, {});

    Object.keys(aggregated).forEach((receiptNo) => {
      const { total_months } = aggregated[receiptNo];
      aggregated[receiptNo].interest_payment_periods = formatPeriod(total_months);
    });

    return aggregated;
  }, [interestData]);

  // Fetch TOTAL pawn count (no amount filter)
  const fetchTotalPawnCount = useCallback(async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          search_text: "",
          place_search: "",
          limit: 1,
          offset: 0,
        }),
      });

      const responseData = await response.json();
      if (responseData.head.code === 200) {
        setTotalPawnRecords(responseData.body.total_records || 0);
      }
    } catch (error) {
      console.error("Error fetching total pawn count:", error);
    }
  }, []);

  // Fetch all pawn data once
  const loadAllPawnData = useCallback(async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "", action: "without_pagination" }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        const processedData = responseData.body.pawnjewelry.map((item) => ({
          ...item,
          jewel_product: JSON.parse(item.jewel_product || "[]"),
        }));
        setAllPawnData(processedData);
      }
    } catch (error) {
      console.error("Error fetching all pawn data:", error);
    }
  }, []);

  // Client-side filtering & pagination
  const processPawnData = useCallback(() => {
    if (allPawnData.length === 0) return;

    if (isMajorChangeRef.current) {
      setTableLoading(true);
    }

    let filtered = allPawnData;

    // 1. Tab Filter
    if (tabKey === "below") {
      filtered = filtered.filter((item) => parseFloat(item.original_amount || 0) < 20000);
    } else {
      filtered = filtered.filter((item) => parseFloat(item.original_amount || 0) >= 20000);
    }

    // 2. Search & Place Filters
    if (searchTerm) {
      filtered = filtered.filter((item) => {
        const mobile = item.mobile_number ? String(item.mobile_number) : "";
        const receipt = item.receipt_no ? String(item.receipt_no) : "";
        const custName = item.customer_details ? item.customer_details.toLowerCase() : "";
        const searchLower = searchTerm.toLowerCase();
        return mobile.includes(searchLower) || receipt.includes(searchLower) || custName.includes(searchLower);
      });
    }

    if (placeSearchTerm) {
      filtered = filtered.filter((item) =>
        String(item.place || "").toLowerCase().includes(placeSearchTerm.toLowerCase())
      );
    }

    // 3. Date Filters
    if (fromDate || toDate) {
      filtered = filtered.filter((item) => {
        let matchesDate = true;
        const itemDate = new Date(item.pawnjewelry_date);
        itemDate.setHours(0, 0, 0, 0);

        if (fromDate) {
          const start = new Date(fromDate);
          start.setHours(0, 0, 0, 0);
          if (itemDate < start) matchesDate = false;
        }
        if (toDate) {
          const end = new Date(toDate);
          end.setHours(0, 0, 0, 0);
          if (itemDate > end) matchesDate = false;
        }
        return matchesDate;
      });
    }

    // 4. Status Filter
    if (statusFilter === "recovered") {
      filtered = filtered.filter((item) => item.status === "நகை மீட்கபட்டது");
    } else if (statusFilter === "active") {
      filtered = filtered.filter((item) => item.status !== "நகை மீட்கபட்டது");
    }

    // 5. Pending Days Filter
    if (fromDays !== "" || toDays !== "") {
      filtered = filtered.filter((item) => {
        const { months, days } = parsePeriod(item.interest_payment_period);
        // Using 30.4167 days per month makes 12 months exactly 365 days
        const totalPendingDays = Math.round((months * 30.4167) + days);

        let matchesDays = true;
        if (fromDays !== "" && totalPendingDays < parseInt(fromDays, 10)) {
          matchesDays = false;
        }
        if (toDays !== "" && totalPendingDays > parseInt(toDays, 10)) {
          matchesDays = false;
        }
        return matchesDays;
      });
    }

    // 6. Alert Status Filter
    if (alertStatusFilter === "sent") {
      filtered = filtered.filter((item) => {
        const isSent = sentWhatsAppAlerts.some((alert) => String(alert) === String(item.receipt_no)) ||
          sentSmsAlerts.some((alert) => String(alert) === String(item.receipt_no));
        return isEligibleForAlert(item.interest_payment_period) && isSent;
      });
    } else if (alertStatusFilter === "unsent") {
      filtered = filtered.filter((item) => {
        const isSent = sentWhatsAppAlerts.some((alert) => String(alert) === String(item.receipt_no)) ||
          sentSmsAlerts.some((alert) => String(alert) === String(item.receipt_no));
        return isEligibleForAlert(item.interest_payment_period) && !isSent;
      });
    }

    setFilteredPawnRecords(filtered.length);

    // Pagination
    const offset = (currentPage - 1) * itemsPerPage;
    const paginated = filtered.slice(offset, offset + itemsPerPage);

    setUserData(paginated);

    if (isMajorChangeRef.current) {
      setTableLoading(false);
      isMajorChangeRef.current = false;
    }
  }, [allPawnData, currentPage, itemsPerPage, searchTerm, placeSearchTerm, tabKey, fromDate, toDate, statusFilter, fromDays, toDays, alertStatusFilter, sentWhatsAppAlerts, sentSmsAlerts]);

  const fetchDatajewelpawncustomer = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/customer.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "", action: "without_pagination" }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        setcustomerData(responseData.body.customer);
        setTotalRecords(responseData.body.total_records);
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  const fetchDatarecovery = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/pawnrecovery.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "", action: "without_pagination" }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        const sortedData = responseData.body.pawn_recovery.map((user) => ({
          ...user,
          jewel_product: JSON.parse(user.jewel_product || "[]"),
        }));
        setUserrecoveryData(sortedData);
        setpawnrecoverTotalRecords(responseData.body.total_records);
      }
    } catch (error) {
      console.error("Error fetching recovery data:", error);
    }
  };

  const fetchinterestData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/interest.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "" }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        setInterestData(responseData.body.interest);
      }
    } catch (error) {
      console.error("Error fetching interest data:", error);
    }
  };

  const fetchCompanyInfo = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/company.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "" }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        const companyList = Array.isArray(responseData.body.company)
          ? responseData.body.company
          : [responseData.body.company];
        if (companyList.length > 0 && companyList[0]?.company_name) {
          setCompanyName(companyList[0].company_name);
        }
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  // Debounced search trigger
  const triggerSearch = useCallback(() => {
    setCurrentPage(1);
    // Note: we don't set isMajorChangeRef.current = true here
    // → no loading during search
  }, []);

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      triggerSearch();
    }, 600);
  };

  const handleClear = () => {
    setSearchTerm("");
    setPlaceSearchTerm("");
    setFromDate("");
    setToDate("");
    setStatusFilter("");
    setFromDays("");
    setToDays("");
    setAlertStatusFilter("");
    setCurrentPage(1);
    // Clear is also considered search-like → no loading
  };

  // Initial data load
  useEffect(() => {
    const loadInitialData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          fetchDatarecovery(),
          fetchDatajewelpawncustomer(),
          fetchinterestData(),
          fetchTotalPawnCount(),
          loadAllPawnData(),
          fetchCompanyInfo(),
        ]);
      } catch (err) {
        console.error("Initial load error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();

    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [loadAllPawnData]);

  // Re-process data when pagination / tab / search changes
  useEffect(() => {
    processPawnData();
  }, [processPawnData]);

  // When tab changes → mark as major change
  const handleTabSelect = (k) => {
    setTabKey(k);
    setCurrentPage(1);
    isMajorChangeRef.current = true;
  };

  // When page changes → mark as major change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    isMajorChangeRef.current = true;
  };

  const getTamilAlertMessage = (customerName, receiptNo, pawnDate) => {
    return `திரு / திருமதி ${customerName}, அடகு எண் - ${receiptNo}, நகை தேதி ${dayjs(
      pawnDate
    ).format("DD-MM-YYYY")} அன்று வைக்கப்பட்டுள்ளது. வட்டி செலுத்த வேண்டிய தேதி கடந்து விட்டதால், தங்களது நகையை அசல் தொகையை கட்டித் திருப்பி கொள்ளுமாறும் அல்லது வட்டித் தொகையை கட்டி தங்களது நகையை புதுப்பித்துக் கொள்ளுமாறும் கேட்டுக் கொள்கிறோம்.\n\nஇப்படிக்கு:\n${companyName}`;
  };

  const generateWhatsAppURL = (mobileNumber, message) => {
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/91${mobileNumber}?text=${encodedMessage}`;
  };

  const renderTable = (data) => (
    <div className="balance-table-wrapper">
      <Table bordered hover responsive className="table">
        <thead>
          <tr>
            <th>தேதி</th>
            <th>அடகு எண்</th>
            <th>வாடிக்கையாளர் பெயர்</th>
            <th>இடம்</th>
            <th>மொபைல் எண்</th>
            <th>அசல் தொகை</th>
            <th>வட்டி விகிதம்</th>
            <th>நகை எடை</th>
            <th>S/WGT எடை</th>
            <th>மொத்த எடை</th>
            <th>அடகு பொருட்கள்</th>
            <th>நகை மதிப்பு (அடகு)</th>
            <th>வட்டி நிலுவை</th>
            <th>வட்டி செலுத்தியது</th>
            <th>மொத்த மதிப்பீடு</th>
            <th>தற்போதைய நகை மதிப்பு</th>
            <th>alert</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item) => (
              <tr key={item.id}>
                <td>{dayjs(item.pawnjewelry_date).format("DD-MM-YYYY")}</td>
                <td>{item.receipt_no}</td>
                <td>{item.customer_details}</td>
                <td>{item.place}</td>
                <td>{item.mobile_number}</td>
                <td>{item.original_amount}</td>
                <td>{item.interest_rate}</td>
                <td>{item.jewel_weight}</td>
                <td>{item.net_weight}</td>
                <td>{item.total_weight}</td>
                <td>{item.pledged_items}</td>
                <td>{(item.original_amount / item.total_weight).toFixed(2)}</td>
                <td>
                  <div className="dashboard">
                    <span>{item.interest_payment_period}</span>
                    <span style={{ color: "green" }}>
                      ₹{item.interest_payment_amount.toFixed(2)}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="dashboard">
                    <span>
                      {aggregateInterestData[item.receipt_no]?.interest_payment_periods || "N/A"}
                    </span>
                    <span style={{ color: "green" }}>
                      ₹{aggregateInterestData[item.receipt_no]?.total_interest_income?.toFixed(2) || 0}
                    </span>
                  </div>
                </td>
                <td>
                  ₹{(
                    parseFloat(item.original_amount || 0) +
                    parseFloat(item.interest_payment_amount || 0) +
                    parseFloat(aggregateInterestData[item.receipt_no]?.total_interest_income || 0)
                  ).toFixed(2)}
                </td>
                <td>
                  ₹{(
                    (parseFloat(item.original_amount || 0) +
                      parseFloat(item.interest_payment_amount || 0) +
                      parseFloat(aggregateInterestData[item.receipt_no]?.total_interest_income || 0)) /
                    item.total_weight
                  ).toFixed(2)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {item.status !== "நகை மீட்கபட்டது" && isEligibleForAlert(item.interest_payment_period) && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "center" }}>
                      <button
                        onClick={(e) => {
                          const isSent = sentWhatsAppAlerts.some(alert => String(alert) === String(item.receipt_no));
                          if (isSent) {
                            e.preventDefault();
                            const newAlerts = sentWhatsAppAlerts.filter(alert => String(alert) !== String(item.receipt_no));
                            setSentWhatsAppAlerts(newAlerts);
                            localStorage.setItem("sentWhatsAppAlerts", JSON.stringify(newAlerts));
                          } else {
                            const msg = getTamilAlertMessage(item.customer_details, item.receipt_no, item.pawnjewelry_date);
                            const url = generateWhatsAppURL(item.mobile_number, msg);
                            window.open(url, "_blank");
                            const newAlerts = [...sentWhatsAppAlerts, item.receipt_no];
                            setSentWhatsAppAlerts(newAlerts);
                            localStorage.setItem("sentWhatsAppAlerts", JSON.stringify(newAlerts));
                          }
                        }}
                        className="whatsapp-btn"
                        style={sentWhatsAppAlerts.some(alert => String(alert) === String(item.receipt_no)) ? { backgroundColor: "#28a745", borderColor: "#28a745", color: "#fff" } : {}}
                      >
                        {sentWhatsAppAlerts.some(alert => String(alert) === String(item.receipt_no)) ? "WhatsApp அனுப்பப்பட்டது" : "WhatsApp அனுப்பு"}
                      </button>
                      <a
                        href={`sms:${item.mobile_number}?body=${encodeURIComponent(getTamilAlertMessage(item.customer_details, item.receipt_no, item.pawnjewelry_date))}`}
                        onClick={(e) => {
                          const isSent = sentSmsAlerts.some(alert => String(alert) === String(item.receipt_no));
                          if (isSent) {
                            e.preventDefault();
                            const newAlerts = sentSmsAlerts.filter(alert => String(alert) !== String(item.receipt_no));
                            setSentSmsAlerts(newAlerts);
                            localStorage.setItem("sentSmsAlerts", JSON.stringify(newAlerts));
                          } else {
                            const newAlerts = [...sentSmsAlerts, item.receipt_no];
                            setSentSmsAlerts(newAlerts);
                            localStorage.setItem("sentSmsAlerts", JSON.stringify(newAlerts));
                          }
                        }}
                        style={{
                          backgroundColor: sentSmsAlerts.some(alert => String(alert) === String(item.receipt_no)) ? "#28a745" : "#007BFF",
                          color: "#fff",
                          padding: "5px 5px",
                          borderRadius: "5px",
                          textDecoration: "none",
                          display: "inline-block",
                        }}
                      >
                        {sentSmsAlerts.some(alert => String(alert) === String(item.receipt_no)) ? "SMS அனுப்பப்பட்டது" : "SMS அனுப்பு"}
                      </a>
                    </div>
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  <span
                    className={`badge ${item.status === "நகை மீட்கபட்டது" ? "bg-success" : "bg-danger"}`}
                    style={{ minWidth: "20px", minHeight: "20px", display: "inline-block" }}
                  ></span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="18" className="text-center">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );

  return (
    <Container>
      {loading ? (
        <div className="spinner-container">
          <LoadingOverlay isLoading={loading} />
        </div>
      ) : (
        <>
          <Row>
            <Col lg="3" md="6" xs="12" className="py-3">
              <div className="counter-card cyan">
                <span><MdOutlinePerson /></span>
                <span className="count-numbers plus bold">{totalRecords}</span>
                <span className="count-name regular">வாடிக்கையாளர்</span>
              </div>
            </Col>
            <Col lg="3" md="6" xs="12" className="py-3">
              <div className="counter-card blue">
                <span><AiFillGolden /></span>
                <span className="count-numbers plus bold">{totalPawnRecords}</span>
                <span className="count-name regular">நகை அடகு</span>
              </div>
            </Col>
            <Col lg="3" md="6" xs="12" className="py-3">
              <div className="counter-card green">
                <span><RiDeviceRecoverLine /></span>
                <span className="count-numbers plus bold">{pawnrecovertotalRecords}</span>
                <span className="count-name regular">நகை மீட்பு</span>
              </div>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col lg="12">
              <h5 className="mb-3">நகை அடகு விவரங்கள்</h5>

              <Row className="mb-3">
                <Col lg="2" md="4" xs="6" className="mb-2">
                  <label style={{ fontSize: "12px", marginBottom: "2px" }}>From Date (முதல்)</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={handleInputChange(setFromDate)}
                  />
                </Col>
                <Col lg="2" md="4" xs="6" className="mb-2">
                  <label style={{ fontSize: "12px", marginBottom: "2px" }}>To Date (வரை)</label>
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={handleInputChange(setToDate)}
                  />
                </Col>
                <Col lg="2" md="4" xs="6" className="mb-2">
                  <label style={{ fontSize: "12px", marginBottom: "2px" }}>Status</label>
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={handleInputChange(setStatusFilter)}
                  >
                    <option value="">All</option>
                    <option value="active">Active (நிலுவையில்)</option>
                    <option value="recovered">Recovered (மீட்கபட்டது)</option>
                  </select>
                </Col>
                <Col lg="2" md="3" xs="6" className="mb-2">
                  <label style={{ fontSize: "12px", marginBottom: "2px" }}>From Days (வட்டி நிலுவை)</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="0"
                    value={fromDays}
                    onChange={handleInputChange(setFromDays)}
                  />
                </Col>
                <Col lg="2" md="3" xs="6" className="mb-2">
                  <label style={{ fontSize: "12px", marginBottom: "2px" }}>To Days</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="365"
                    value={toDays}
                    onChange={handleInputChange(setToDays)}
                  />
                </Col>
                <Col lg="2" md="3" xs="6" className="mb-2 d-flex align-items-end">
                  <button
                    type="button"
                    className="warning-btn-custom w-100 fw-bold shadow-sm"
                    onClick={() => {
                      setFromDays("365");
                      setToDays("");
                      triggerSearch();
                    }}
                    style={{
                      fontSize: "12px",
                      backgroundColor: "#ffc107",
                      color: "#000",
                      border: "1px solid #e0a800",
                      borderRadius: "5px",
                      height: "35px"
                    }}
                  >
                    1 Year+ (365 Days)
                  </button>
                </Col>
                <Col lg="3" md="6" xs="12" className="mb-2">
                  <label style={{ fontSize: "12px", marginBottom: "2px" }}>Search</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="மொபைல் எண், அடகு எண் அல்லது வாடிக்கையாளர் பெயர்"
                    value={searchTerm}
                    onChange={handleInputChange(setSearchTerm)}
                  />
                </Col>
                <Col lg="2" md="6" xs="12" className="mb-2">
                  <label style={{ fontSize: "12px", marginBottom: "2px" }}>Place</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="இடம்"
                    value={placeSearchTerm}
                    onChange={handleInputChange(setPlaceSearchTerm)}
                  />
                </Col>
                <Col lg="2" md="4" xs="12" className="mb-2">
                  <label style={{ fontSize: "12px", marginBottom: "2px" }}>Alert Status</label>
                  <select
                    className="form-control"
                    value={alertStatusFilter}
                    onChange={handleInputChange(setAlertStatusFilter)}
                  >
                    <option value="">All</option>
                    <option value="sent">Sent</option>
                    <option value="unsent">Unsent</option>
                  </select>
                </Col>
                <Col lg="2" md="3" xs="6" className="mb-2 d-flex align-items-end">
                  <Button variant="secondary" onClick={handleClear} className="warning-btn-custom w-100 fw-bold shadow-sm" style={{
                    fontSize: "12px",
                    backgroundColor: "#ffc107",
                    color: "#000",
                    border: "1px solid #e0a800",
                    borderRadius: "5px",
                    height: "35px"
                  }}>
                    Clear Fillters
                  </Button>
                </Col>
              </Row>

              <div className="position-relative">
                <Tabs
                  activeKey={tabKey}
                  onSelect={handleTabSelect}
                  className="mb-3"
                >
                  <Tab eventKey="below" title="அசல் தொகை < ₹20,000">
                    {renderTable(userData)}
                  </Tab>
                  <Tab eventKey="above" title="அசல் தொகை ≥ ₹20,000">
                    {renderTable(userData)}
                  </Tab>
                </Tabs>

                <LoadingOverlay isLoading={tableLoading} />
              </div>

              <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="text-muted">
                  Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                  {Math.min(currentPage * itemsPerPage, filteredPawnRecords)} of{" "}
                  {filteredPawnRecords} records
                </div>
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-outline-primary d-flex align-items-center"
                    style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    <GrPrevious />
                  </button>
                  <span className="fw-bold fs-6">Page {currentPage}</span>
                  <button
                    className="btn btn-outline-primary d-flex align-items-center"
                    style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                    disabled={currentPage * itemsPerPage >= filteredPawnRecords}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    <GrNext />
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          <footer className="text-center py-4 mt-5 border-top">
            <p className="text-muted mb-0">
              © {new Date().getFullYear()} {companyName} | All Rights Reserved
            </p>
          </footer>
        </>
      )}
    </Container>
  );
};

export default DashBoard;